import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BrifingFormService } from 'src/@core/services/briefing-form/brifing-form.service';

@Component({
  selector: 'hour4u-admin-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  projectForm: FormGroup;
  id: string = '';

  constructor(private fb: FormBuilder, private router: Router, private briefingFormService: BrifingFormService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.initializeForm();
    this.route.paramMap.subscribe(params => {

      this.id = params.get('id');
      // if (this.id) {
      //   this.loadData(this.id);
      // }
    });

    // const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    // if (userDetails) {
    //   this.projectForm.patchValue(userDetails);
    // }
  }

  // loadData(id: string) {
  //   // Fetch data based on the id
  //   this.briefingFormService.getBriefingFormById(id).subscribe(data => {
  //     // Assuming data is structured to match form controls
  //     this.projectForm.patchValue(data);
  //   }, error => {
  //     console.error('Failed to load data for id:', id, error);
  //   });
  // }

  initializeForm() {
    this.projectForm = this.fb.group({
      name: ['', Validators.required],
      companyName: ['', Validators.required],
      mobile: ['', Validators.required],
      email: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.projectForm.valid) {
      localStorage.setItem("userDetails", JSON.stringify(this.projectForm.value));

      this.router.navigate([`briefing/about/form/${this.id}`]);
    }
  }
}
